export default
  {
    "header": {
      "title": "Fyndsampo",
      "login": "Logga in",
      "logout": "Logga ut",
      "notification": {
        "logoutSuccess": ""
      }
    },
    "": "",
    "loginPage": {
      "title": "Logga in",
      "email": "e-post",
      "password": "Lösenord",
      "login": "Logga in",
      "signup": "Registrera dig",
      "forgotPassword": "Glömt lösenordet?",
      "loginWith": "Logga in med",
      "googleLogin": "Logga in med Google",
      "notAMemberYet": "Inte medlem än?",
      "error": {
        "emptyField": "E-post och lösenord saknas!"
      }
    },
    "signupPage": {
      "title": "Logga in",
      "username": "Användarnamn",
      "email": "e-post",
      "password": "Lösenord",
      "signup": "Logga in",
      "alreadyAMember": "Redan medlem?",
      "login": "Logga in",
      "registrationDone": "Registeringen lyckades!"
    },
    "nearByPage": {
      "map": {
        "mapLayers": {
          "backGroundMap": "Bakgrundskarta (CHECK!)",
          "topographicalMap": "Terrängkarta",
          "googleMaps": "Google Maps"
        },
        "overLays": {
          "arkeologiset_loydot": "Arkeologiska fynd",
          "arkeologiset_kohteet_alue": "Arkeologiskt kulturarv, områdena av fornlämningar och övriga kulturarvsobjekt",
          "arkeologiset_kohteet_piste": "Arkeologiskt kulturarv, fornlämningar och övriga kulturarvsobjekt",
          "maailmanperinto_alue": "Världsarvsområden",
          "maailmanperinto_piste": "Världsarvsobjekt",
          "rakennusperinto_alue": "Byggnadsarv, områdena av skyddade byggnader",
          "rakennusperinto_piste": "Byggnadsarv, skyddade byggnader",
          "arkeologisten_kohteiden_alakohteet_piste": "Arkeologista kulturarv, underobjekt",
          "rky_alue": "Byggda kulturmiljöer av riksintressen, RKY - områdesobjekt",
          "rky_piste": "Byggda kulturmiljöer av riksintressen, RKY - punktformade objekt",
          "rky_viiva": "Byggda kulturmiljöer av riksintressen, RKY - streckformade objekt"
        },
        "alert": {
          "zoomAlertTitle": "Zooma in",
          "zoomAlertContent": "",
          "zoomAlertConfirmation": "Ok",
          "gettingLocationFailed": ""
        },
        "mapContent": {
          "name": "Namn",
          "town": "Stad",
          "link": "Länk",
          "more": "Mer"
        }
      },
      "tabs": {
        "map": "Karta",
        "heatmap": "Heatmap",
        "statistics": "Statistik",
        "table": "Tabell"
      },
      "statistics": {
        "chart": {
          "selectProperty": "Välj egenskap",
          "material": "Material",
          "type": "Föremålskategori",
          "period": "Datering"
        }
      },
      "table": {
        "title": "Föremålsklassificiering",
        "material": "Material",
        "type": "Föremålstyp",
        "period": "Datering",
        "municipality": "Kommun",
        "province": "Landskap",
        "specification": "Fyndsätt",
        "previewImage": "Förhandsgranskning av bilden",
        "notProvidedValue": "Ej tillgänglig",
        "noAdditionalInformation": "Tillägsinformation ej tillgänglig!",
        "more": ""
      }
    },
    "myFindsPage": {
      "header": {
        "title": "Mina fynd",
        "show": "",
        "orderSelect": {
          "orderBy": "",
          "date": "",
          "municipality": "",
          "totalFinds": ""
        }
      },
      "more": "Se ytterligare information",
      "share": "Dela",
      "continue": "Fortsätt uppdatera",
      "status": "Status",
      "noFindsInfo": "Fyndrapporten har ingen information",
      "noFindsError": "Inga fynd hittade!",
      "container": {
        "report": "Rapportera in fynd",
        "municipality": "Kommun",
        "time": "datum {d, date, short}",
        "timeClock": "tid",
        "finds": "Innehåller (nummer) fynd"
      },
      "statuses": {
        "draft": "Utkast",
        "await_review": "Väntar på granskning",
        "in_review": "Granskas",
        "validated": "Bekräftad",
        "rejected": "Avvisad",
        "peding_user": "Väntar på tilläggsinformation"
      }
    },
    "notFoundPage": {
      "pageNotFound": "Ooops! Vi kunde inte hitta sidan!",
      "goToHomePage": "Gå tillbaka till startsidan"
    },
    "legalityCheckerPage": {
      "alert": {
        "allowed": {
          "header": "",
          "description": "Vi kunde inte hitta någon fornlämning i din närhet"
        },
        "forbidden": {
          "header": "Du får inte gräva på denna plats!",
          "description": "Man får inte utan särskilt tillstånd grava i marken vid en fast fornlämning som fredas genom lagen om fornminnen (295/1963), vid ett objekt so antas vara en sådan eller i ett område som skyddas genom naturvårdslagen. Det rekommenderas att man inte gräver i marken i närheten av en fredad fornlämning, det vill säga inom ett avstånd på 200 meter från objektet."
        }
      }
    },
    "overview": {
      "title": "Sammanfattning",
      "notProvidedValue": "Anges inte",
      "findSite": {
        "title": "Fyndplatsdetaljer",
        "photos": "Fyndplatsfotografier",
        "location": "Position",
        "additionalMaterials": "Ytterligare material"
      },
      "find": {
        "title": "Detaljer om fynd",
        "subTitle": "Fynd",
        "photos": "Foton",
        "depth": "Djup",
        "type": "Typ",
        "timing": "Period",
        "material": "Material"
      }
    },
    "report": {
      "stepOne": "Anvisningar",
      "stepTwo": "Detaljer",
      "stepThree": "Extra",
      "stepFour": "Klart!",
      "skip": "Hoppa över",
      "optionalSection": "",
      "reportSent": "Din rapportering är inskickad!",
      "back": "Tillbaka",
      "notifications": {
        "photoDeletionError": ""
      },
      "questionZero": {
        "question": "Vill du bekanta dig med anvisningarna innan du skickar in?",
        "help": "Frågorna hjälper dig vidare. Välj alternativet som passar",
        "buttonOne": "Ja tack!",
        "buttonTwo": "Nej tack!"
      },
      "questionProvideHelp": {
        "question": "Fint, här är de lämpligaste anvisningarna",
        "help": "Väl ett av alternativen",
        "buttonOne": "Fortsätt",
        "options": {
          "optionOne": "Allmänna instruktioner",
          "optionTwo": "Startkit",
          "optionThree": "Instruktioner för att rapportera"
        }
      },
      "questionFindTimeDetermining": {
        "question": "",
        "help": "",
        "buttonOne": "",
        "buttonTwo": ""
      },
      "questionFindLocation": {
        "question": "",
        "help": "",
        "buttonOne": "Klart, var god fortsätt"
      },
      "questionFindPhotos": {
        "question": "Var god och tillägg fotografier på fyndet",
        "help": "",
        "buttonOne": "Fortsätt"
      },
      "questionFindSitePhotos": {
        "question": "Var god och tillägg fotografier från fyndplatsen",
        "help": "",
        "buttonOne": "Fortsätt"
      },
      "questionFindDate": {
        "question": "",
        "help": "",
        "buttonOne": "Fortsätt",
        "selectionText": ""
      },
      "questionFindDepth": {
        "question": "",
        "help": "",
        "label": "",
        "depth": "",
        "buttonOne": "Fortsätt",
        "useSlider": "",
        "depthUnit": "cm"
      },
      "questionFindMaterial": {
        "question": "",
        "help": "",
        "buttonOne": "Fortsätt",
        "label": "",
        "placeholder": ""
      },
      "questionFindType": {
        "question": "",
        "help": "",
        "buttonOne": "Fortsätt",
        "label": "",
        "placeholder": ""
      },
      "questionFindTime": {
        "question": "",
        "help": "",
        "buttonOne": "Fortsätt",
        "label": "",
        "placeholder": ""
      },
      "questionAdditionalMaterials": {
        "question": "",
        "help": "",
        "buttonOne": "Fortsätt"
      },
      "questionAddAnotherFind": {
        "question": "Vill du tillägga ett annat fynd?",
        "help": "",
        "buttonOne": "Ja tack!",
        "buttonTwo": "Nej tack!"
      },
      "questionOverview": {
        "buttonOne": "Ser bra ut, var god och sänd!"
      },
      "questionReportSent": {
        "question": "",
        "help": "Ditt fynd har sänts. Du kommer att få ett meddelande snart."
      },
      "questionAddMoreInformation": {
        "question": "",
        "help": "",
        "buttonOne": "Ja tack!",
        "buttonTwo": "Nej tack!"
      }
    },
    "findMaterials": {
      "stone": "Sten",
      "slag": "Slagg",
      "glass": "Glas",
      "metal": "Metall",
      "leather": "Läder",
      "wood": "Trä",
      "iron": "Järn",
      "bronze": "Brons",
      "porcelain": ""
    },
    "bottomNavBar": {
      "home": "Start",
      "mine": "Mina fynd",
      "nearby": "I närheten",
      "report": "Rapportera",
      "more": "Mer"
    },
    "helpBar": {
      "saveAs": "Spara utkast",
      "delete": "Ta bort utkast",
      "notifications": {
        "noDataAvailable": "",
        "reportDeleted": "",
        "reportSent": ""
      },
      "dialog": {
        "header": "",
        "closeBtn": ""
      }
    },
    "photoRenderer": {
      "infoText": "",
      "errorHeader": "Fotografiet för stort",
      "errorText": "",
      "confirmationBtn": "Ok",
      "dialog": {
        "title": "",
        "takePhoto": "",
        "selectFromGallery": "",
        "cancel": ""
      }
    },
    "morePage": {
      "headers": {
        "usefulTools": "",
        "tutorials": "",
        "recommendedApps": ""
      },
      "checkLegality": "",
      "fhaHowToReport": "Att anmäla ett fynd",
      "fhaCulturalHeritageMaterial": "Hur det arkeologiska kulturarvet skyddas?",
      "photoFrame": ""
    },
    "facetDrawer": {
      "facetedSearch": "",
      "searchResults": "",
      "searchCriteria": "",
      "emptyBtn": "",
      "facetCriteria": {
        "type": "",
        "material": "",
        "period": "",
        "municipality": "",
        "province": ""
      }
    },
    "langMenu": {
      "abbreviation": {
        "english": "EN",
        "finnish": "FI",
        "swedish": "SV"
      }
    },
    "smartHelper": {
      "table": "",
      "map": "",
      "nearbySpecific": "",
      "overall": ""
    },
    "appHomePage": {
      "contentContainer": {
        "recentFinds": "",
        "guides": "",
        "applicationTagline": "",
        "headerTitle": "",
        "learnMore": "",
        "name": ""
      }
    },
    "answerOptions": {
      "date": "",
      "approximateDate": "",
      "additionalMaterials": "",
      "btnEnterManually": "",
      "dialog": {
        "title": "",
        "content": "",
        "latitude": "",
        "longitude": "",
        "cancel": "",
        "insert": ""
      }
    },
    "autocompleter": {
      "noOptions": "",
      "loading": "",
      "save": ""
    }
  };